export default __webpack_public_path__ + "88ad479a4787db312b9b7c86e3b21d14.jpg";